export default "dist/images/components-design-separator-control-curve-3.da5eb6d.png";